// Copy for the HostelNMC brand page, in both languages.
//
// The page is a compact hub: a title and three ways in. It has to be complete
// with an EMPTY CMS, so every string has a default here; the tagline and brand
// name are overridden by Strapi the moment an editor fills them in.
//
// Every claim has to be defensible: no ratings, no awards, no guest counts, no
// founding dates. Those belong to the owner, not to a default.
const COPY = {
  en: {
    skip: "Skip to content",
    navLabel: "Where to next",
    eyebrow: "Hostels · Indonesia",
    tagline: "Eco-conscious hostels in Indonesia, named after a Greek goddess.",
    intro: "We keep to the standard that comes with the name.",
    actions: {
      property: {
        title: "Hebe Bogor",
        body: "Our eco hostel in Bogor, West Java — rooms, rates and photos.",
      },
      guest: {
        title: "Staying with us",
        body: "Guest portal: order food, pay your deposit, manage your booking.",
      },
      insights: {
        title: "Stories & guides",
        body: "Things to do, eco tours and slow days around Bogor.",
      },
    },
    story: {
      eyebrow: "What we are",
      heading: "Small places, run carefully",
      body: "HostelNMC runs a small number of eco-conscious properties in Indonesia. We keep them small on purpose: it is the only way to stay answerable for the things that matter — how much water and power a stay uses, where the food comes from, and whether the people at the desk are from the neighbourhood.",
      points: [
        {
          title: "Built to use less",
          body: "Solar where the roof allows it, refill stations instead of bottles, and rooms designed to stay cool without air conditioning running all day.",
        },
        {
          title: "Staffed locally",
          body: "The desk, housekeeping and kitchen are hired from the surrounding neighbourhood, on permanent contracts rather than seasonal ones.",
        },
        {
          title: "Honest about the trade-offs",
          body: "We publish what we have not solved yet. A property that claims to have fixed everything is a property that has stopped measuring.",
        },
      ],
    },
    properties: {
      eyebrow: "Where to stay",
      heading: "Our properties",
      cta: "See rooms and rates",
    },
    insights: {
      eyebrow: "Stories & guides",
      heading: "Things to do around Bogor",
      body: "Walks, eco tours, food worth the detour, and slow days near the botanical gardens — written by the people who work here.",
      cta: "Read the guides",
    },
    privacy: "Privacy",
    terms: "Terms",
  },

  id: {
    skip: "Lewati ke konten",
    navLabel: "Mau ke mana",
    eyebrow: "Hostel · Indonesia",
    tagline: "Hostel ramah lingkungan di Indonesia, dinamai dari dewi Yunani.",
    intro: "Kami menjaga standar yang menyertai nama itu.",
    actions: {
      property: {
        title: "Hebe Bogor",
        body: "Hostel ramah lingkungan kami di Bogor, Jawa Barat — kamar, tarif, dan foto.",
      },
      guest: {
        title: "Sedang menginap",
        body: "Portal tamu: pesan makanan, bayar deposit, kelola pemesanan.",
      },
      insights: {
        title: "Cerita & panduan",
        body: "Aktivitas, eco tour, dan hari santai di sekitar Bogor.",
      },
    },
    story: {
      eyebrow: "Tentang kami",
      heading: "Tempat kecil, dikelola dengan cermat",
      body: "HostelNMC mengelola beberapa penginapan ramah lingkungan di Indonesia. Kami sengaja menjaganya tetap kecil: hanya dengan begitu kami bisa bertanggung jawab atas hal yang penting — berapa banyak air dan listrik yang terpakai, dari mana makanan berasal, dan apakah orang di resepsionis berasal dari lingkungan sekitar.",
      points: [
        {
          title: "Dirancang hemat",
          body: "Panel surya bila atap memungkinkan, isi ulang air alih-alih botol sekali pakai, dan kamar yang tetap sejuk tanpa AC menyala seharian.",
        },
        {
          title: "Dikelola warga sekitar",
          body: "Resepsionis, housekeeping, dan dapur direkrut dari lingkungan sekitar, dengan kontrak tetap, bukan musiman.",
        },
        {
          title: "Jujur soal kekurangan",
          body: "Kami menuliskan apa yang belum berhasil kami perbaiki. Penginapan yang mengaku sudah sempurna adalah penginapan yang berhenti mengukur.",
        },
      ],
    },
    properties: {
      eyebrow: "Tempat menginap",
      heading: "Penginapan kami",
      cta: "Lihat kamar dan tarif",
    },
    insights: {
      eyebrow: "Cerita & panduan",
      heading: "Kegiatan di sekitar Bogor",
      body: "Jalan kaki, eco tour, makanan yang layak diburu, dan hari santai dekat Kebun Raya — ditulis oleh orang-orang yang bekerja di sini.",
      cta: "Baca panduannya",
    },
    privacy: "Privasi",
    terms: "Ketentuan",
  },
};

export default COPY;
